import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, Subject, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class JWTService {
  private _token = new BehaviorSubject<string | null>(null);
  private keyStorage = 'nest-baas:user';

  constructor() {
    this._token.next(localStorage.getItem(this.keyStorage));
    this._token.subscribe((token) => {
      if (token) {
        localStorage.setItem(this.keyStorage, token);
      } else {
        localStorage.removeItem(this.keyStorage);
      }
    });
  }

  isLoggedIn(): Observable<boolean> {
    return this._token.pipe(map((token) => !!token));
  }

  getAccessToken(): string | null {
    return this._token.getValue();
  }

  setAccessToken(token: string) {
    this._token.next(token);
  }

  reset() {
    this._token.next(null);
  }
}
